import { createContext, useContext } from 'react';
import type { PostcodeLookupOutcome } from '@jfh/intake-shared';

/**
 * How address questions look a postcode up (23/10/2026). The public form and
 * the portal provide one; without it (the builder canvas, Try it out) address
 * questions show their lines as before.
 */
export type LookupPostcode = (postcode: string) => Promise<PostcodeLookupOutcome>;
export const PostcodeLookupContext = createContext<LookupPostcode | null>(null);

export function usePostcodeLookup(): LookupPostcode | null {
  return useContext(PostcodeLookupContext);
}
